<template>
    <v-container
            id="service-card"
            fluid
            tag="section"
            pt-0
    >
        <v-row class="mt-1">
            <v-col cols="12" md="5">
                <base-material-card>
                    <template v-slot:heading>
                        <div class="subtitle-1 font-weight-light d-flex">
                            <div>
                                <v-tooltip
                                        v-model="copyLinkSuccess"
                                        right
                                        internal-activator
                                        :open-on-hover="false"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <span @click="copyLink" v-bind="attrs"
                                          v-on="on">{{ formTitle }}</span>
                                    </template>
                                    {{$vuetify.lang.t('$vuetify.page.action.copyLinkSuccess')}}
                                </v-tooltip>
                            </div>
                        </div>
                    </template>
                    <div class="mt-2" v-if="currentService">
                        <v-row>
                            <v-col
                                    cols="12"
                            >
                                <v-select
                                        v-if="canChangeStatus"
                                        dense
                                        outlined
                                        :label="$vuetify.lang.t('$vuetify.page.ServicesCard.status')"
                                        v-model="currentService.serviceStatus.id"
                                        :items="serviceStatusDictList"
                                        item-text="name"
                                        item-value="id"
                                        v-on:change="changeStatus"
                                        hide-details="auto"
                                >
                                </v-select>

                                <v-text-field
                                        v-else
                                        :label="$vuetify.lang.t('$vuetify.page.ServicesCard.status')"
                                        v-model="currentService.serviceStatus.name"
                                        dense
                                        readonly
                                        outlined
                                        hide-details="auto"
                                ></v-text-field>
                                <service-executor-panel
                                        :service-id="serviceId"
                                        :can-add="false"
                                ></service-executor-panel>
                            </v-col>
                            <v-col
                                    cols="12"
                                    v-if="canJoinService"
                            >
                                <v-btn

                                    small
                                    class="mr-2"
                                    @click="joinService(currentService.id)"
                                >
                                    Взять в работу
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                    cols="8"
                            >
                                <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.page.ServicesCard.clientName')"
                                        v-model="currentService.client.name"
                                        dense
                                        readonly
                                        outlined
                                        hide-details="auto"
                                        append-outer-icon="mdi-card-account-details-outline"
                                        @click:append-outer="showClientCard"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                    cols="4"
                            >
                                <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.page.ServicesCard.serviceImportance')"
                                        v-model="currentService.serviceImportance.name"
                                        dense
                                        readonly
                                        outlined
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="6"
                            >
                                <v-text-field
                                        v-model="currentService.serviceDate"
                                        :label="$vuetify.lang.t('$vuetify.page.ServicesCard.serviceDate')"
                                        readonly
                                        outlined
                                        dense
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                          <v-col cols="6">
                            <v-text-field
                                :disabled="!currentService.client.id"
                                dense
                                outlined
                                ref="clientPhone"
                                :label="$vuetify.lang.t('$vuetify.page.ServicesCard.clientPhone')"
                                v-model="currentService.clientPhone"
                                hide-details="auto"
                                v-mask="'+7 (###) ###-##-##'"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                    cols="12"
                                    md="4"
                            >
                                <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.page.ServicesCard.department')"
                                        v-model="currentService.department.name"
                                        dense
                                        readonly
                                        outlined
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                    cols="12"
                                    md="4"
                            >
                                <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.page.ServicesCard.serviceType')"
                                        v-model="currentService.serviceType.name"
                                        dense
                                        readonly
                                        outlined
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                    cols="12"
                                    md="4"
                            >
                                <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.page.ServicesCard.serviceVisitType')"
                                        v-model="currentService.serviceVisitType.name"
                                        dense
                                        readonly
                                        outlined
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                    cols="12">
                                <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.page.ServicesCard.serviceTypeDescription')"
                                        v-model="currentService.serviceTypeDescription"
                                        dense
                                        readonly
                                        outlined
                                        hide-details="auto"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                    cols="12">
                                <v-textarea
                                        :label="$vuetify.lang.t('$vuetify.page.ServicesCard.description')"
                                        v-model="currentService.description"
                                        dense
                                        readonly
                                        outlined
                                        hide-details="auto"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                      <v-row v-if="!isNew">
                        <v-col
                            cols="12">
                          <v-textarea
                              dense
                              outlined
                              :label="$vuetify.lang.t('$vuetify.page.ServicesCard.solution')"
                              v-model="currentService.solution"
                              hide-details="auto"
                              append-icon="mdi-send"
                              @click:append="saveSolution"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </div>
                </base-material-card>
            </v-col>
            <v-col  cols="12" md="7" v-if="currentService">
                <chat-panel></chat-panel>
                <chat-multi-media-show></chat-multi-media-show>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ServiceExecutorPanel from "@/view/dashboard/components/service/ServiceExecutorPanel";
    import ChatPanel from "@/view/dashboard/components/chat/ChatPanel";
    import ChatMultiMediaShow from "@/view/dashboard/components/chat/ChatMultiMediaShow";
    import {mask} from 'vue-the-mask'

    export default {
        name: "ExecutorServiceCard",
      directives: {mask},
        components: {ChatMultiMediaShow, ChatPanel, ServiceExecutorPanel},
        props: {
            serviceId: String
        },
        created() {
            this.currentService = null
            this.$store.dispatch('retrieveChat')
            if (this.isNew) {
                this.setService(this.defaultService)
                this.editMode = true
            } else {
                this.$store.dispatch('retrieveExecutorService', this.serviceId).then((data) => {
                    this.setService(data)
                })
            }
            this.$store.dispatch('retrieveClientDictionaryList')
            this.$store.dispatch('retrieveDepartmentDictionaryList')
            this.$store.dispatch('retrieveServiceTypeDictionaryList')
            this.$store.dispatch('retrieveServiceStatusDictionaryList')
            this.$store.dispatch('retrieveServiceImportanceDictList')
            this.$store.dispatch('retrieveServiceVisitTypeDictList')
        },
        computed: {
            isNew() {
                return this.serviceId === '00000000-0000-0000-0000-000000000000'
            },
            formTitle() {
                return this.currentService ? this.currentService.number : ''
            },
            clientUserDictList() {
                return this.$store.getters.clientDictionaryList
            },
            departmentDictList() {
                return this.$store.getters.departmentDictionaryList
            },
            serviceTypeDictList() {
                return this.$store.getters.serviceTypeDictionaryList
            },
            serviceImportanceDictList() {
                return this.$store.getters.serviceImportanceDictionaryList
            },
            serviceStatusDictList() {
                return this.$store.getters.serviceStatusDictionaryList
            },
            serviceVisitTypeDictList() {
                return this.$store.getters.serviceVisitTypeDictList
            },
            canChangeStatus(){
                return this.currentService && this.currentService.executors.length > 0 && this.currentService.executors.find(item => item.id === this.$store.getters.userId)
            },
            canJoinService(){
                return this.currentService && this.currentService.executors.length === 0
            }
        },
        data() {
            return {
                currentService: null,
                defaultService: {
                    id: null,
                    client: {
                        id: null,
                    },
                    clientPhone: null,
                    solution: null,
                    number: '-',
                    department: {
                        id: null,
                    },
                    serviceType: {
                        id: null,
                    },
                    serviceTypeDescription: null,
                    serviceImportance: {
                        id: null,
                    },
                    description: null,
                    externalNumber: null,
                    executors: [],
                    serviceDate: null
                },
                valid: !this.formError,
                vue: this,
                editMode: false,
                copyLinkSuccess: false,
                loading: false
            }
        },
        methods: {
            save() {
                if (this.$refs.form.validate()) {
                    if (!this.currentService.id) {
                        this.currentService.id = this.$uuid.v4()
                        this.$store.dispatch('createService', this.currentService).then(() => {
                            this.$router.push({path: `/pages/service/card/${this.currentService.id}`})
                            this.$router.go(0)
                            // this.editMode = false
                            // this.$store.dispatch('retrieveService', this.currentService.id).then((data) => this.currentService = Object.assign({}, data))
                        }).catch(() => this.currentService.id = null)
                    } else {
                        this.$store.dispatch('storeService', this.currentService).then((data) => {
                            this.setService(data)
                            this.editMode = false
                        })
                    }
                }
            },
            edit(){
                this.editMode = true
            },
            setService(data){
                this.currentService = Object.assign({}, data)

                if(this.currentService.serviceDate) {
                    this.currentService.serviceDate = this.moment(this.currentService.serviceDate).format('YYYY-MM-DD HH:mm')
                }

                if (!this.currentService.client) {
                    this.currentService.client = {
                        id: null,
                        name: null
                    }
                }
                if (!this.currentService.serviceVisitType) {
                    this.currentService.serviceVisitType = {
                        id: null,
                        name: null
                    }
                }

                if(this.currentService.activities.length > 0) {
                    this.$store.dispatch('retrieveChat', {
                        chatId: this.currentService.activities[0].id,
                        commentLimit: 20
                    })
                }
            },
            cancel(){
                if(this.isNew) {
                    this.$router.push({path: `/pages/service/list`})
                } else {
                    this.$store.dispatch('retrieveService', this.currentService.id).then((data) => this.currentService = Object.assign({}, data))
                    this.editMode = false
                }
            },
            changeStatus(){
                this.$store.dispatch('changeServiceStatus', {
                    serviceId: this.currentService.id,
                    statusId: this.currentService.serviceStatus.id
                })
            },
            showClientCard(){
                if(!this.currentService.client){
                    return
                }
                let clientId = this.currentService.client.id
                let routeData = this.$router.resolve({
                    name: 'ClientsCard',
                    params: {clientId}
                });
                window.open(routeData.href, '_blank');
            },
            copyLink() {
                this.copyToClipboard(window.location.href)
                this.copyLinkSuccess = true
                setTimeout(() => {
                    this.copyLinkSuccess = false
                }, 2000);
            },
            joinService(serviceId){
                this.$store.dispatch('executorServiceJoin', serviceId).then(() =>
                    this.$router.go(0)
                )
            },
            saveSolution(){
              this.loading = true
              this.$store.dispatch('storeService', this.currentService).then(() => {
                this.loading = false
              })
            }
        }
    }
</script>

<style scoped>

</style>